import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { IconButton } from '@mui/material';
import useAppShellSx from '../../hooks/useAppShellSx';
import useSidebarTransition from '../../hooks/useSidebarTransition';

export default function SidebarCollapseToggle({ collapsed, onToggle }) {
  const sx = useAppShellSx();
  const { getToggleMotionSx } = useSidebarTransition();

  return (
    <IconButton
      size="small"
      onClick={onToggle}
      aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      sx={{
        ...sx.sidebarCollapseToggle,
        ...getToggleMotionSx(collapsed),
      }}
    >
      {collapsed ? (
        <ChevronRightIcon className="sidebar-toggle-icon" sx={sx.sidebarCollapseToggleIcon} />
      ) : (
        <ChevronLeftIcon className="sidebar-toggle-icon" sx={sx.sidebarCollapseToggleIcon} />
      )}
    </IconButton>
  );
}
